
  import createMeisterIcons from '../src/createMeisterIcons';

  const Cross = createMeisterIcons("cross", [["path",{"fill":"currentColor","d":"M18.18 5.82a.75.75 0 0 1 0 1.06l-11.3 11.3a.75.75 0 1 1-1.06-1.06l11.3-11.3a.75.75 0 0 1 1.06 0","key":"4336fc063152acd13b5f57bfe8272c6d132e2477","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M5.82 5.82a.75.75 0 0 1 1.06 0l11.3 11.3a.75.75 0 0 1-1.06 1.06L5.82 6.88a.75.75 0 0 1 0-1.06","key":"d89f0afd9dc775eb2f09f66871649179b06461f3","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Cross
  